export const getBaseUrl = () => {
  if (process.env.NEXT_PUBLIC_API_URL) {
    return process.env.NEXT_PUBLIC_API_URL
  }

  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`
  }

  return 'http://localhost:3000'
}
export function formatTwoDigits(number: number) {
  return number.toString().padStart(2, '0')
}
export const formattedPrice = (price: number) => {
  return price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}
export const getVND = (price: number, suffix: string = '') =>
  (price?.toString() || '0').replace(/\.(\d{1,2})$/, ',$1').replace(/\B(?=(\d{3})+(?!\d))/g, '.') +
  (suffix || 'Đ')

export const capitalizeFirstLetter = (str: string) => {
  if (!str) return str
  return str?.charAt(0)?.toUpperCase() + str?.slice(1)
}
export const isClient = () => typeof window !== 'undefined'

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const buildQuery = (query: string, variables?: any) => {
  if (!variables) {
    return `?query=${encodeURIComponent(query)}`
  }
  return `?query=${encodeURIComponent(query)}&variables=${encodeURIComponent(JSON.stringify(variables))}`
}
export const buildQueryV2 = (query: string, variables?: any) => {
  query = query.replace(/\s+/g, ' ').trim()
  if (!variables) {
    return `?query=${encodeURIComponent(query)}`
  }
  return `?query=${encodeURIComponent(query)}&variables=${encodeURIComponent(JSON.stringify(variables))}`
}
/**
 * Helper function for Promise.allSettled that extracts values or provides fallbacks
 * @param promises Array of promises to settle
 * @param fallbacks Array of fallback values for rejected promises (optional)
 * @returns Promise that resolves to an array of values or fallbacks
 */
export const allSettledWithFallbacks = async <T extends readonly unknown[]>(
  promises: readonly [...{ [K in keyof T]: Promise<T[K]> }],
  fallbacks?: { [K in keyof T]?: T[K] }
): Promise<{ [K in keyof T]: T[K] | null }> => {
  const results = await Promise.allSettled(promises)

  return results.map((result, index) => {
    if (result.status === 'fulfilled') {
      return result.value
    }

    // Log the error for debugging
    console.warn(`Promise ${index} rejected:`, result.reason)

    // Return fallback value if provided, otherwise return null
    if (fallbacks && fallbacks[index] !== undefined) {
      return fallbacks[index]
    }

    return null
  }) as { [K in keyof T]: T[K] | null }
}

/**
 * Simpler version that just extracts fulfilled values or returns null for rejected
 * @param promises Array of promises to settle
 * @returns Promise that resolves to an array of values or null for rejected promises
 */
export const allSettledSimple = async <T>(promises: Promise<T>[]): Promise<(T | null)[]> => {
  const results = await Promise.allSettled(promises)

  return results.map((result, index) => {
    if (result.status === 'fulfilled') {
      return result.value
    }

    console.warn(`Promise ${index} rejected:`, result.reason)
    return null
  })
}

export function chunkArray<T>(array: T[], chunkSize: number): T[][] {
  const chunks: T[][] = []
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }
  return chunks
}

export function formatNumber(num: number): string {
  if (!num && num !== 0) return ''
  if (num >= 1_000_000_000) {
    const value = num / 1_000_000_000
    return (Math.round(value * 100) / 100).toString().replace(/\.0+$/, '') + 'B'
  }
  if (num >= 1_000_000) {
    const value = num / 1_000_000
    return (Math.round(value * 100) / 100).toString().replace(/\.0+$/, '') + 'M'
  }
  if (num >= 1_000) {
    const value = num / 1_000
    return (Math.round(value * 100) / 100).toString().replace(/\.0+$/, '') + 'K'
  }
  return num.toString()
}
export function getTheImageUrl(url: string) {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  return `${process.env.NEXT_PUBLIC_API_URL?.replace('/graphql', '')}/media/${url}`
}

 /**
 * Helper function để optimize ảnh qua Next.js Image Optimization API
 */
export const getOptimizedImageUrl = (src: string, width: number = 1200, quality: number = 75): string => {
  if (!src) return src
  
  // Nếu ảnh đã là data URI hoặc blob, return nguyên bản
  if (src.startsWith('data:') || src.startsWith('blob:')) return src
  
  // Encode URL để tránh lỗi với special characters
  const encodedSrc = encodeURIComponent(src)
  
  // Sử dụng Next.js Image Optimization API
  return `/_next/image?url=${encodedSrc}&w=${width}&q=${quality}`
}